export default __webpack_public_path__ + "e28ed59e2c88b8b93858252ff10e517d.png";